<template>

  <!-- On Delivery (ON_DELIVERY, RETURNING_TO_HQ) -->
  <route-list-data-table
      title="On Delivery"
      defaultSortField="on_delivery_at"
      defaultSortOrder="dsc"
      :myRoutes="true"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      routeClickGoTo="route-info" />

</template>

<script>
import RouteListDataTable from '@/components/routes/RouteListDataTable'

export default {
  name: 'DeliveryListOnDeliveryPage',

  components: {
    RouteListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name', width: '180px' },
        { text: 'Orders', sortable: false, value: 'orders', width: '170px' },
        { text: 'Actions', sortable: false, align: 'center', value: 'id' },
        { text: 'Delivery Date', value: 'delivery_date' },
        { text: 'Start At', value: 'scheduled_start_time' },
        { text: 'Est. Return', value: 'estimated_return_time' },
        { text: 'Driver', value: 'driver_user_id' },
        { text: 'Vehicle', value: 'vehicle_id' },
        { text: 'Delivery Started', value: 'on_delivery_at' },
        { text: 'Status', value: 'route_status' }
      ],
      status: ['ON_DELIVERY', 'RETURNING_TO_HQ'],
      assocs: 'orders,driver,vehicle'
    }
  }
}
</script>

<style scoped>
</style>
